<dx-load-panel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="isLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"></dx-load-panel>
